import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
// import '../src/assets/js/sb-admin-2.min.js'
import '../src/assets/css/sb-admin-2.min.css';
import VueTelInput from 'vue-tel-input';
import Storage from '@/helpers/storage.js';
import axios from 'axios';
import VueSessionStorage from 'vue-sessionstorage'
import Toasted from 'vue-toasted';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
 
Vue.component('multiselect', Multiselect)
Vue.use(Toasted)
Vue.prototype.$http = axios;
Vue.config.productionTip = false;
Vue.use(VueTelInput)
Vue.use(VueSessionStorage)

const token = Storage.get('token');

// if(token){
// 	Axios.defaults.headers.common['Authorization'] = `Token ${token}`
// }
const currentUser = Storage.get('currentUser').organisation

// axios.interceptors.response.use( response => {
// 	return response
// },(err) => {
// 	if(err.response.status !== 401) {
// 		return new Promise( (resolve, reject)=> {
// 			reject(err)
// 		})
// 	}
    
// 	if(err.response.status == 401) {
// 		if(currentUser) {
// 			router.replace('/accounts/signin/')
// 			return 
// 		}
// 		router.replace('/admin/login')
// 	}
	
// })
new Vue({	
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
